module.exports = __webpack_public_path__ + "static/media/google-icon.f4675c3f.svg";